import { remoteJSON } from './remote';

export const getClientToken = async (id: number) => {
	const response = (await remoteJSON(`/oauth/authorize?client_id=${id}`)) as GetClientTokenResponse;

	return response.data.code;
};
